// extracted by mini-css-extract-plugin
export default {"page":"styles_page__-zm+z","head":"styles_head__AYK8k","canvas":"styles_canvas__9O+Xm"};